import * as m from "../../lib/model";

export const parseMoney = (s) => {
  if (typeof s === "number") return s;
  const mt = String(s || "").match(/\$?\s*([\d.,]+)(?:\s*[–-]\s*\$?([\d.,]+))?\s*(T|B|M|K)?/i);
  if (!mt) return 0;
  const n = parseFloat(mt[1].replace(/,/g, ""));
  const u = { T: 1e12, B: 1e9, M: 1e6, K: 1e3 }[(mt[3] || "").toUpperCase()] || 1;
  return isNaN(n) ? 0 : n * u;
};
export const parsePct = (s) => { const mt = String(s || "").match(/([\d.]+)\s*%/); return mt ? +mt[1] : 0; };
export const years = (s) => (String(s || "").match(/20\d{2}/g) || []).map(Number);
// Deal figures are written in full ($9,300,000); only market-size scale keeps B/T shorthand.
export const fmtBig = (n) => (n >= 1e12 ? `$${(n / 1e12).toFixed(1)}T` : n >= 1e9 ? `$${(n / 1e9).toFixed(1)}B` : m.fmt$(n));
// Short enough to sit inside a donut hole: $11.6M, $940K.
export const fmtTight = (n) => (n >= 1e9 ? `$${(n / 1e9).toFixed(1)}B` : n >= 1e6 ? `$${(n / 1e6).toFixed(n >= 1e8 ? 0 : 1)}M` : n >= 1e3 ? `$${Math.round(n / 1e3)}K` : m.fmt$(n));
export const grow = (base, g, n) => base * Math.pow(1 + (g || 0) / 100, n);
export const entryMult = (M) => m.entryMultiple(M);
export const filled = (arr, k) => (Array.isArray(arr) ? arr.filter((r) => String(r?.[k] ?? "").trim()) : []);
export const DECK_GREEN = "var(--lime)";
export const DECK_GOLD = "var(--text3)";
// Every slice has to stay visible on white paper, so the ramp bottoms out well above zero.
export const DONUT_OPACITY = [1, 0.76, 0.56, 0.4, 0.28, 0.2, 0.14];

export const defaultLevers = (M) => {
  const entry = entryMult(M), exit = m.coerceNum(M.exitMult), lift = entry > 0 ? exit - entry : 0;
  return [
    { title: "Owner-salary normalisation", text: `A market salary of ${m.fmt$(M.salary)} replaces owner add-backs; true earnings underwritten at ${m.fmt$(m.trueEarnings(M))}.` },
    { title: "Debt paydown", text: `${m.fmt$(m.loanAmt(M))} of senior debt amortises over ${M.loanYrs} years, converting cash flow into equity.` },
    { title: "Organic growth", text: `${M.sdeGrowth}% annual earnings growth on a ${m.fmtPct(m.grossMargin(M))} gross-margin base.` },
    { title: "Multiple expansion", text: `Entry at ${m.fmtX(entry)} versus a ${m.fmtX(exit)} exit assumption — ${m.fmtX(Math.max(0, lift))} of multiple lift.` },
  ];
};
